<template>
  <div id="validationErrors" class="alert alert-warning mt-4">
    <div class="inner">
      <h2>
        <span class="fa fa-exclamation-triangle"></span>
        Please check your answers
      </h2>
      <ol>
        <li v-for="(value, key) in errors" :key="key" v-html="value[0]">
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    errors: Object
  }
}
</script>